import { IFilterRecords } from 'src/app/common/models/IFilterRecords';


export class SetFilterRecords {
    static readonly type = '[IFilterRecords] Set RecordsOf Data';

    constructor(public data: IFilterRecords) {}
}

export class ClearFilterRecords {
    static readonly type = '[IFilterRecords] Clear RecordsOf State';

    constructor() {}
}
